import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IZippyChangeEvent, ZippyEventType, subject } from '@df/legacy/ui/zippy/zippy.abstract';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ZippyService } from '@df/legacy/ui/zippy/zippy.service';
import { Login } from '@df/session/login/login.interfaces';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../module/legacy/forms/mui-input.directive';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { ViewPasswordComponent } from '../../ui/form/view-password.component';
import { CheckoutAccountComponent } from './checkout-account.component';

@Component({
    selector: 'checkout-account-alternative',
    templateUrl: './checkout-account-alternative.html',
    styleUrls: ['./checkout-account-alternative.scss'],
    standalone: true,
    imports: [
        FormsModule,
        TranslationModule,
        ZippyModule,
        CommonModule,
        ResultComponent,
        ActionComponent,
        InputWrapComponent,
        MuiInputDirective,
        ViewPasswordComponent,
        InputWrapBodyDirective
    ]
})
export class CheckoutAccountAlternativeComponent extends CheckoutAccountComponent {
    private zippyService = inject(ZippyService);

    private initiated = false;

    get expandableGuestId(): string[] {
        return this.checkoutFormComponent.getExpandableId('guest');
    }

    get expandableLoginId(): string[] {
        return this.checkoutFormComponent.getExpandableId('login');
    }

    status?: 'guest' | 'login';
    opened?: 'guest' | 'login';

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(subject.subscribe(event => this.onEvent(event as IZippyChangeEvent)));
        this.init()
    }

    init = this.timeoutService.debounce(()=>{
        (!this.isChecked() || !this.email) && this.setCheckResult();
    },50)

    onEvent(event: IZippyChangeEvent) {
        if (!event.stopped) {
            if (event.type === ZippyEventType.change) {
                if (!event.visible && event.id.name === this.opened) {
                    this.opened = undefined;
                }
            }
        }
    }

    select = this.timeoutService.debounce((status: 'guest' | 'login', force?: boolean): void => {
        if (this.status !== status || !this.initiated || force) {
            !this.initiated && (this.initiated = true);
            if (this.form) {
                this.form.submitAttempt = false;
            }
            force && this.checkoutFormComponent.goToStep('account');
            this.status = status;

            this.openZippy(status);
            if (status === 'login') {
                this.leaveGuestCheckout();
            } else if (status === 'guest') {
                this.setGuestCheckout();
            }
            this.opened = status;
        }
    }, 50);

    openZippy(status) {
        this.zippyService.open(this.checkoutFormComponent.getExpandableId(status));
    }

    /**
     * Checks if guest checkout is used
     */
    override get isGuestCheckout(): boolean {
        return !this.accountRequired && this.checkoutFormComponent.isGuestCheckout;
    }

    /**
     * Check results setter
     * Check result is the result of request checking if customer exits
     */
    protected override setCheckResult(checkResult?: Login.IResponseAccountExists) {
        if (checkResult || !this.checkStatus.busy) {
            if (checkResult?.exists) {
                this.select('login');
            } else {
                this.select('guest');
            }
        }
        super.setCheckResult(checkResult);
    }
}
